import { render, staticRenderFns } from "./clientInfoButtonAndModal.vue?vue&type=template&id=4aa269fd&"
import script from "./clientInfoButtonAndModal.vue?vue&type=script&lang=js&"
export * from "./clientInfoButtonAndModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports